module.exports = __webpack_public_path__ + "img/polizas-icon.08ab1bac.svg";